import type { GetUserResponse } from 'src/types/users';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const STORE_NAME = 'Users';

export type UsersStoreState = {
  isUserChecked: boolean;
  setIsUserChecked: (isUserChecked: boolean) => void;
  user: GetUserResponse | null;
  setUser: (user: GetUserResponse | null) => void;
};

const initialState = {
  isUserChecked: false,
  user: null,
};

export const useUsersStore = create<UsersStoreState>()(
  devtools(
    (set) => ({
      ...initialState,
      setIsUserChecked: (isUserChecked) => set(() => ({ isUserChecked })),
      setUser: (user) => set(() => ({ user })),
    }),
    { name: STORE_NAME },
  ),
);
